import type { Dayjs } from 'dayjs';

export const WEEKLY_REPEAT_COUNTS = [4, 8, 12] as const;

export const toDateKey = (value: Dayjs) => value.startOf('day').format('YYYY-MM-DD');

export const sortDatesAscending = (dates: Dayjs[]) =>
  [...dates].sort((left, right) => left.startOf('day').valueOf() - right.startOf('day').valueOf());

export const formatDateChip = (value: Dayjs) => value.format('ddd, MMM D, YYYY');

export const addServiceDate = (dates: Dayjs[], nextDate: Dayjs) => {
  const normalized = nextDate.startOf('day');
  const key = toDateKey(normalized);
  if (dates.some((entry) => toDateKey(entry) === key)) {
    return dates;
  }
  return sortDatesAscending([...dates, normalized]);
};

export const addWeeklyDates = (dates: Dayjs[], weekCount: number) => {
  if (!dates.length || weekCount < 1) return dates;

  const anchor = sortDatesAscending(dates)[0].startOf('day');
  let nextDates = dates;
  for (let week = 1; week <= weekCount; week += 1) {
    nextDates = addServiceDate(nextDates, anchor.add(week, 'week'));
  }
  return nextDates;
};
